import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-12 w-12 items-center justify-center rounded-lg icon-background" }

import Image from "@/views/blocks/shared/section/media/image/Image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    src: {},
    alt: {},
    backgroundColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0e70f2a7": (_ctx.backgroundColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Image, {
      src: _ctx.src,
      alt: _ctx.alt,
      class: "h-6 w-6",
      width: "24",
      height: "24"
    }, null, 8, ["src", "alt"])
  ]))
}
}

})